// extracted by mini-css-extract-plugin
export default {"WelcomeBox":"styles_WelcomeBox__IDCR8","WelcomeBox-content":"styles_WelcomeBox-content__Xn5sN","WelcomeBox-content-arrowContainer":"styles_WelcomeBox-content-arrowContainer__mfDKc"};